const API_BASE = process.env.REACT_APP_API_URL || "";

export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}

export function sortHomeSections(rows) {
  return safeArray(rows)
    .slice()
    .sort((a, b) => Number(a?.position || 0) - Number(b?.position || 0));
}

export function clamp(number, min, max) {
  return Math.max(min, Math.min(number, max));
}

export function isImageUrl(url = "") {
  const value = String(url || "").trim();

  return (
    /\.(png|jpe?g|webp|gif|avif|bmp|svg)(\?.*)?$/i.test(value) ||
    value.includes("res.cloudinary.com") ||
    value.startsWith("/uploads/")
  );
}

export function getYoutubeId(url = "") {
  try {
    const parsed = new URL(url);

    if (parsed.hostname.includes("youtu.be")) {
      return parsed.pathname.slice(1);
    }

    if (parsed.hostname.includes("youtube.com")) {
      return parsed.searchParams.get("v");
    }
  } catch {
    return null;
  }

  return null;
}

export function toMediaUrl(url = "") {
  const value = String(url || "").trim();

  if (!value) return "";

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/uploads/")) {
    const cleanBase = API_BASE.replace(/\/$/, "");
    return `${cleanBase}${value}`;
  }

  return value;
}

export function canEditMedia(sectionId) {
  return [17, 18, 19].includes(Number(sectionId));
}

export function validateSectionMedia(sectionId, value) {
  const url = String(value || "").trim();

  if (!canEditMedia(sectionId)) return "";

  if (!url) {
    return "Veuillez renseigner un média.";
  }

  if ([17, 18].includes(Number(sectionId)) && !isImageUrl(url)) {
    return "Veuillez fournir un lien d’image valide.";
  }

  if (Number(sectionId) === 19 && !getYoutubeId(url)) {
    return "Veuillez fournir un lien YouTube valide.";
  }

  return "";
}

export function calculateHomeSectionsStats(sections) {
  const rows = safeArray(sections);

  const active = rows.filter((section) => !!section.is_active).length;
  const hidden = rows.length - active;
  const withMedia = rows.filter((section) =>
    String(section?.mediaURL || "").trim()
  ).length;
  const editableMedia = rows.filter((section) => canEditMedia(section.id)).length;

  return {
    total: rows.length,
    active,
    hidden,
    withMedia,
    editableMedia,
  };
}